import React from "react";
import BannerSection from "../components/BannerSection";
import Cards from "../components/Cards";
import FeaturedProducts from "../components/FeaturedProducts";
import "../../src/App.css";

function Home() {
  return (
    <>
      <BannerSection />
      <FeaturedProducts />
      <Cards />

      <section className="py-5 user-reviews-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img
                src={require("../assets/user-reviews.png")}
                className="w-100"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
